import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import FormularioPesquisa from './components/FormularioPesquisa';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  
  html, body, #root {
    width: 100%;
    background: #f5f5f5;
    font-family: 'Roboto', sans-serif;
  }
  
  #root {
    color: #666;
    display: flex;
    justify-content: center;
  }
`;

const Container = styled.div`
  width: 900px;
  background: #FFF;
  box-shadow: 1px 1px 10px 1px #999;
  border-radius: 3px;
  font-size: 14px;
  color: #666;
  font-family: Arial, Helvetica, sans-serif;
  
  @media (max-width: 900px) {
    width: 100%;
  }
  
  @media (max-width: 720px) {
    width: 100%;
    box-shadow: none;
  }
  
  @media (max-width: 450px) {
    font-size: 11px;
  }
`;

const Body = styled.div`
  width: 100%;
  height: 100%;
  
  @media (max-width: 450px) {
    padding: 0px;
  }
`;

const App: React.FC = () => {
  return (
    <Container>
      <GlobalStyle />
      <Router>
        <Body>
          <Routes>
            <Route 
              path="/pesquisa/:id" 
              element={<FormularioPesquisa />} 
            />
            <Route 
              path="/" 
              element={
                <div style={{ textAlign: 'center', padding: '50px' }}>
                  <h1 style={{ color: '#555', fontSize: '16px', fontWeight: '200', marginBottom: '10px' }}>
                    Sistema de Mapeamento de Saúde
                  </h1>
                  <p style={{ color: '#777', fontSize: '14px', fontWeight: '200' }}>
                    Acesse uma pesquisa através da URL: /pesquisa/[id]
                  </p>
                  <p style={{ color: '#777', fontSize: '14px', fontWeight: '200' }}>
                    Exemplo: /pesquisa/c34114fb-07e7-4aab-844c-84d5e9ae3b9c
                  </p>
                </div>
              } 
            />
          </Routes>
        </Body>
      </Router>
    </Container>
  );
};

export default App;